/*
 * @Description: 
 * @Author: houcw
 * @Date: 2023-06-11 11:16:43
 * @LastEditTime: 2023-10-26 12:33:36
 * @LastEditors: houcw
 * @Reference: 
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import VueRouter from 'vue-router'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index'
import "./mock/index.js"
import '@/style/index.scss'
import '@/permission' // permission control
Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
